import { AllocationBase } from '../../accounting/abstract/allocation-base.model';

export class PurchaseInvoiceAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'PurchaseInvoiceAllocation';

}
